import React from 'react'
import PropTypes from 'prop-types'

import { LoggedInOutButton } from '../loggedInOutButton'
import { CarouselButtons } from '../../atoms/carouselButtons'
import { PaginationDots } from '../../atoms/paginationDots'
import { ResponsiveImage } from '../../atoms/responsiveImage'
import { Text, Title } from '../../atoms/text'
import {
  StyledDesktopCarouselWrapper,
  StyledSlide,
  StyledSlidesWrapper,
  StyledContainer,
  WaveImageContainer,
} from './styles'
import { Wave } from '../../atoms/wave'
import { useGatsbyImageData } from '../../../hooks/graphqlStaticQuery/useGatsbyImageData'
import { useEventTracking } from '../../../context/eventTrackingProvider'

const DesktopCarousel = (props) => {
  const {
    slides,
    index,
    onNext,
    onPrevious,
    useGatsbyImage,
    onSlideFocus = () => {},
    onSlideBlur = () => {},
    onBannerClick,
  } = props
  const { length } = slides
  const { findImage } = useGatsbyImageData()
  const { trackEvent, EVENT_NAMES, EVENT_LOCATIONS } = useEventTracking()

  const handleLoggedInOutButtonClick = (slide, banner_i) => {
    const firstCta = slide?.cta_logged_out[0];

    if(!!firstCta && firstCta.link.includes("/registro")) {
      trackEvent(EVENT_NAMES.SIGNUP_STARTED, {
          location: slide.add_cpf_field ? EVENT_LOCATIONS.CPF_BANNER : EVENT_LOCATIONS.LOBBY_BANNER
        });
    }

    onBannerClick({
      ...slide,
      position: banner_i,
    })
}
  
  return (
    <StyledDesktopCarouselWrapper>
      <CarouselButtons
        showButtons={slides.length > 1}
        onNext={onNext}
        onPrevious={onPrevious}
      >
        <StyledSlidesWrapper length={length} index={index}>
          {slides.map((slide, banner_i) => (
            <StyledSlide
              key={`banner-slide-${banner_i}`}
              backgroundColor={slide.background_color}
              length={length}
              isShown={banner_i == index}
            >
              <StyledContainer
                $backgroundColor={slide.background_color}
                useGatsbyImage={useGatsbyImage}
              >
                <Title
                  tagType={slide.header_tag}
                  style={{ color: slide.text_color, marginBottom: 20 }}
                  level={1}
                >
                  {slide.header_text}
                </Title>
                <Text style={{ color: slide.text_color }}>
                  {slide.sub_text}
                </Text>
                <LoggedInOutButton
                  addCpfField={slide.add_cpf_field}
                  loggedIn={slide.cta_logged_in}
                  loggedOut={slide.cta_logged_out}
                  eventId="desktop-carousel"
                  onFocus={onSlideFocus}
                  onBlur={onSlideBlur}
                  onClick={() => handleLoggedInOutButtonClick(slide, banner_i)}
                />
              </StyledContainer>
              <WaveImageContainer>
                <Wave color={slide.background_color} direction="vertical" />
                <ResponsiveImage
                  image={slide.background_image}
                  loading={banner_i === 0 ? 'eager' : 'lazy'}
                  big
                  useGatsbyImage={useGatsbyImage}
                  gatsbyImage={findImage(slide?.background_image?.url)}
                />
              </WaveImageContainer>
            </StyledSlide>
          ))}
        </StyledSlidesWrapper>
      </CarouselButtons>

      <PaginationDots length={length} index={index} />
    </StyledDesktopCarouselWrapper>
  )
}

DesktopCarousel.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      add_cpf_field: PropTypes.bool,
      background_color: PropTypes.string,
      header_tag: PropTypes.string,
      header_text: PropTypes.string,
      sub_text: PropTypes.string,
      text_color: PropTypes.string,
      cta_logged_out: PropTypes.arrayOf(
        PropTypes.shape({
          action_text: PropTypes.string,
          link: PropTypes.string,
          background_color: PropTypes.string,
          text_color: PropTypes.string,
        })
      ),
      cta_logged_in: PropTypes.arrayOf(
        PropTypes.shape({
          action_text: PropTypes.string,
          link: PropTypes.string,
          background_color: PropTypes.string,
          text_color: PropTypes.string,
        })
      ),
      background_image: PropTypes.shape({
        alt: PropTypes.string,
        url: PropTypes.string,
        title: PropTypes.string,
      }),
    })
  ),
  index: PropTypes.number,
  onSlideBlur: PropTypes.func,
  onSlideFocus: PropTypes.func,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  useGatsbyImage: PropTypes.bool,
  onBannerClick: PropTypes.func,
}

export { DesktopCarousel }
